module.exports = require("./pt-MO.js");